import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import axios from './plugins/axios'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import GlobalMessage from './components/GlobalMessage.vue';
Vue.component('custom-message', GlobalMessage); //全局提示

Vue.use(ElementUI)
// import Debounce from '@/plugins/debounce.js'
import { productList } from './plugins/productList';
Vue.prototype.$productList = productList

Vue.config.productionTip = false
Vue.prototype.$axios = axios
// Vue.component('Debounce', Debounce)


import { Stepper, Toast, Uploader, Popup, Pagination, Overlay, Field, Picker, Notify, Swipe, SwipeItem } from 'vant'
Vue.use(Stepper).use(Toast).use(Uploader).use(Popup).use(Pagination).use(Overlay).use(Field).use(Picker).use(Notify).use(Swipe).use(SwipeItem)


import { Area } from 'vant-green';

// 2. 引入组件样式
import 'vant/lib/index.css'

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
